/**
 * currentSeasonId actions
 */
import { SET_CURRENT_SEASON_ID } from './constants';

export function setCurrentSeasonId(seasonId: number) {
    return {
        type: SET_CURRENT_SEASON_ID,
        payload: {
            seasonId
        }
    };
}
